<template>
    <span class="loop-switch" :class="getClassName()" :disabled="shouldDisable()" @click="handleClick">{{ curLabel }}</span>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    //生成默认切换项列表
    function genDefaultItems() {
        return [{
            value: false,
            label: 'ⅹ',
            className: 'false-value'
        }, {
            value: true,
            label: '√',
            className: 'true-value'
        }];
    }

    function getTheItemByValue(items, theValue) {
        items = items || [];
        let itemCount = items.length;
        if(itemCount < 1) {
            return null;
        }
        theValue = typeof theValue == 'undefined' ? null : theValue;
        let theIndex = items.indexOf(theValue, function (item) {
            return item.value == theValue;
        });
        return theIndex == -1 ? null : items[theIndex];
    }

    //
    function getNextItemByValue(items, theValue) {
        items = items || [];
        let itemCount = items.length;
        if(itemCount < 1) {
            return null;
        }
        theValue = typeof theValue == 'undefined' ? null : theValue;
        let theIndex = items.indexOf(theValue, function (item) {
            return item.value == theValue;
        });
        theIndex = ++theIndex % itemCount;
        return items[theIndex];
    }

    export default {
        name: 'swb-loop-switch',
        desc: '循环切换器',
        //
        props: {
            //所有循环切换项
            allItems: {
                type: Array,
                default: genDefaultItems
            },
            iniValue: {
                default: null
            },
            //初始值为null时的相当值
            nullAsValue: {
                //
            },
            disabled: {
                type: Boolean,
                default: false
            },
            //异常值时显示的label
            noValueLabel: {
                type: String,
                default: ''
            },
            noValueClassName: {
                type: String,
                default: 'no-value'
            },
            //自定义信息
            tag: {
                default: null
            }
        },
        //
        data() {
            return {
                curItems: [],
                curItemCount: 0,
                //
                curLabel: null,
                curValue: null
            }
        },
        //
        watch: {
            items(newValue, oldValue) {
                this.init();
            },
            iniValue(newValue, oldValue) {
                this.curValue = this.iniValue;
                //
                this.init();
            }
        },
        //
        mounted() {
            let shouldTriggerChange = false;
            if(this.iniValue == null && (typeof this.nullAsValue != 'undefined')) {
                this.curValue = this.nullAsValue;
                //
                shouldTriggerChange = true;
            }
            else {
                this.curValue = this.iniValue;
            }
            //
            this.init();
            //
            if(shouldTriggerChange && !this.shouldDisable()) {
                this.triggerChange();
            }
        },
        //
        beforeDestroy() {
            //data
            this.curItems = null;
            this.curValue = null;
            //props
            this.allItems = null;
            this.iniValue = null;
            this.tag = null;
        },
        //
        methods: {
            init() {
                this.curItems = this.allItems || genDefaultItems();
                this.curItemCount = this.curItems.length;
                //
                if(this.curItemCount < 2) {
                    console.error('至少要有两个切换项');
                    //
                    this.curValue = null;
                    this.curLabel = this.noValueLabel;
                    //
                    return;
                }
                //
                let curItem = getTheItemByValue(this.curItems, this.curValue);
                if(curItem == null) {
                    this.curValue = null;
                    this.curLabel = this.noValueLabel;
                }
                else {
                    this.curValue = curItem.value;
                    this.curLabel = curItem.label;
                }
            },
            getClassName() {
                let classNames = [];
                if(this.curItemCount < 2) {//无效则返回null
                    classNames.push(this.noValueClassName);
                }
                else {
                    let curItem = getTheItemByValue(this.curItems, this.curValue);
                    if(curItem == null) {
                        classNames.push(this.noValueClassName);
                    }
                    else {
                        classNames.push(curItem.className || '');
                    }
                }
                if(this.shouldDisable()) {
                    classNames.push('disabled');
                }
                return classNames.join(' ');
            },
            shouldDisable() {
                return this.disabled || this.curItemCount < 2;
            },
            triggerChange() {
                let curItem = getTheItemByValue(this.curItems, this.curValue);
                if(curItem != null) {
                    curItem = Utils.merge(curItem);
                    if(this.tag != null) {
                        curItem.tag = this.tag;
                    }
                    this.$emit('change', this.curValue, curItem);
                    //
                    //console.log(curItem);
                }
            },
            handleClick() {
                if(this.shouldDisable()) {
                    return;
                }
                //
                let nextItem = getNextItemByValue(this.curItems, this.curValue);
                //
                if(nextItem == null) {
                    console.error('此处不应该出错');
                }
                else {
                    this.curValue = nextItem.value;
                    this.curLabel = nextItem.label;
                    //
                    this.triggerChange();
                }
            },
            // ------------------------------------------------------------------
            //事件：'change', this.curValue, curItem
            //
            //获取当前项 { value, label , tag}
            getCurItem() {
                if(this.curItemCount < 2) {//无效则返回null
                    return null;
                }
                //
                let curItem = {
                    value: this.curValue,
                    label: this.curLabel
                };
                if(this.tag != null) {
                    curItem.tag = this.tag;
                }
                return curItem;
            },
            //获取当前值（仅 value）
            getCurValue() {
                let curItem = this.getCurItem();
                if(curItem == null) {
                    return undefined;
                }
                return curItem.value;
            }
        }

    }

</script>
<style>
    .loop-switch {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 20px;
        text-align: center;
        vertical-align: middle;
        cursor: default;
        font-size: 18px;
    }

    .loop-switch.disabled {
        opacity: 0.8;
    }


</style>



// WEBPACK FOOTER //
// src/compo/ctrl/LoopSwitch.vue